export default __webpack_public_path__ + "static/media/TopContributors.230f4d8b.png";